function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group 7 Copy 3");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Logo",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Desktop-HD-Copy",
  transform: "translate(-131.000000, -416.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(98.000000, 416.000000)"
}, React.createElement("g", {
  id: "Group-7-Copy-3",
  transform: "translate(33.000000, 0.000000)"
}, React.createElement("path", {
  d: "M137.678151,108.811739 L96.7511505,86.2644935 C89.4574049,82.2447712 89.4574049,71.7549232 96.7511505,67.7352008 L137.676383,45.1897248 C143.198841,42.1466251 144.66254,34.8944939 140.803537,29.9069949 C126.187762,11.0096999 102.986013,-0.895542911 77.0513193,0.0527718731 C36.0907321,1.5513212 3.29185652,35.4234979 3.00194515,76.4451891 C2.70142749,119.225509 37.2609839,154 79.936291,154 C104.766139,154 126.845365,142.225681 140.91137,123.954698 C144.715573,119.011431 143.138738,111.819453 137.678151,108.811739 Z",
  id: "Shape",
  fill: "#FFEB99"
}), React.createElement("path", {
  d: "M35.9217586,76.4452148 C36.1748273,40.5914971 61.2976357,10.1994335 95,2.10868346 C88.3405802,0.518133513 81.3396055,-0.210794774 74.1333449,0.0528228345 C33.1273862,1.55137167 0.292179803,35.4235372 0.00194730234,76.4452148 C-0.298903234,119.225521 34.2989343,154 77.0215122,154 C83.2066501,154 89.2254349,153.269303 94.9911516,151.892831 C60.9401544,143.764927 35.6633811,113.034938 35.9217586,76.4452148 Z",
  id: "Shape",
  fill: "#FFDE55"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "143px",
    height: "154px",
    viewBox: "0 0 143 154",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/treadie-logo-4.762d2fb5.svg";
export { SvgComponent as ReactComponent };